import { render } from "./FormText.vue?vue&type=template&id=6b215fe2"
import script from "./FormText.vue?vue&type=script&lang=js"
export * from "./FormText.vue?vue&type=script&lang=js"

import "./FormText.vue?vue&type=style&index=0&id=6b215fe2&lang=css"
script.render = render

export default script